'use client'

import { useMemo, ReactNode } from 'react'

import ShippingDetailsContext from './ShippingDetailsContext'
import { ItemShippingDetailsModel } from '../../types/item-shipping-details'

type Props = {
  children: ReactNode
  shippingDetails?: ItemShippingDetailsModel | null
}

const ShippingDetailsProvider = ({ children, shippingDetails }: Props) => {
  const shippingDetailsMemo = useMemo(
    () => ({
      shippingDetails,
    }),
    [shippingDetails],
  )

  return (
    <ShippingDetailsContext.Provider value={shippingDetailsMemo}>
      {children}
    </ShippingDetailsContext.Provider>
  )
}

export default ShippingDetailsProvider
